import { cloneDeep } from "lodash";
import { outsourceContentMarketQueryGetKpiValues } from "services/api";

export const getKpiValues = async (detail: any) => {
  const kpiValues = await outsourceContentMarketQueryGetKpiValues({
    case_demand_id: detail.id,
  })
  const kpiValueMap = kpiValues?.data?.reduce((pre, cur) => {
    return {
      ...pre,
      [cur.demand_cooperate_account_id + cur.kpi_code]: cur,
    }
  }, {})
  const newDetail = cloneDeep(detail);
  if (newDetail?.demand_plan_info?.cooperate_accounts) {
    newDetail.demand_plan_info.cooperate_accounts = newDetail?.demand_plan_info?.cooperate_accounts.map((item: any) => {      
      return {
        ...item,
        kpi_values: item?.kpi_values?.map((kpi: any) => {
          if (kpiValueMap[kpi.demand_cooperate_account_id + kpi.kpi_code]) {
            return {
              ...kpi,
              ...kpiValueMap[kpi.demand_cooperate_account_id + kpi.kpi_code]
            }
          }
          return kpi
        })
      }
    })
  }
  return newDetail;
}